
import { defineComponent } from 'vue'
import { mapGetters, mapState, useStore } from 'vuex'
import SettingItem from '@remote/components/SettingItem.vue'
import DeviceList from '@remote/components/DeviceList.vue'
import { getLocalValue, setLocalValue, isXunlei } from '@remote/utils/index'
import { TdVipBadge } from '@xunlei/thunder-ui-vue3/dist/VipBadge'
import '@xunlei/thunder-ui-vue3/dist/VipBadge/styles/VipBadge.css'
import { DEVICE_STATUS, DEVICE_STATUS_CLASS } from '@remote/constant'
import { useHeziVersionStore } from '@remote/store/version'

export default defineComponent({
  components: {
    SettingItem,
    DeviceList,
    TdVipBadge,
  },
  setup: () => {
    document.title = '帐号信息'
    const store = useStore()
    const hzVersionStore = useHeziVersionStore()
    return { store, hzVersionStore, DEVICE_STATUS, DEVICE_STATUS_CLASS }
  },
  computed: {
    ...mapState([
      'user',
      'action',
      // 'deleteCompletely',
      // 'runners',
      // 'all',
      'curDeviceRunner',
      'showSpeedControl',
      'showPathControl',
      'status',
      'deviceInfoWatchData',
    ]),
    ...mapGetters(['showHeader', 'showVip', 'isVip', 'isSuperVip', 'isYear', 'isDownloadAvailable', 'isXlBox']),
    avatarURL (): string {
      return this.user?.avatarURL || 'https://xfile2.a.88cdn.com/file/k/avatar/default'
    },
    nickName (): string {
      return this.user?.nickName || ''
    },
    expiresLast (): number {
      return Math.floor((new Date(this.user.expiresAt).getTime() - Date.now()) / 86400000)
    },
    // list () {
    //   const devices = this.runners.map((id) => this.all[id])
    //   return devices
    // },
    currentStatus (): number {
      return this.curDeviceRunner?.status
    },
    currentName (): string {
      return this.curDeviceRunner?.name
    },
    clientVersion () {
      return (this.deviceInfoWatchData?.client_version ?? '')
    },
    showPoint () {
      return this.$store?.state?.isNative && !getLocalValue('hideMorePoint')
    },
    isXunlei () {
      return isXunlei()
    },
    hasNewVersion (): boolean {
      return this.hzVersionStore.state.hasNewVersion
    },
  },
  watch: {
    action (val) {
      if (val === 'tip-guide') {
        this.store.commit('dialog', { show: false })
        this.store.dispatch('close')
      }
    },
  },
  async mounted () {
    this.$stat({ action: 'mytab_page_show' })
    console.log('deviceInfoWatchData===>', this.deviceInfoWatchData)
    console.log('[Ctrl/Version]versionstate:', this.hzVersionState)
  },
  methods: {
    handleBack () {
      this.$router.go(-1)
    },
    goVip () {
      this.$stat({ action: 'mytab_openvip_btn_click' })
      this.store.dispatch('goVip', { position: 'open' })
    },
    handleShowMore () {
      if (this.showPoint) {
        setLocalValue('hideMorePoint', true)
        this.showPoint = false
      }
      this.$router.push({
        name: 'moreInfo',
        query: this.$route.query,
      })
    },
    handleShowDeviceInfo () {
      if (this.showPoint) {
        setLocalValue('hideMorePoint', true)
        this.showPoint = false
      }
      this.$router.push({
        name: 'deviceInfo',
        query: this.$route.query,
        hash: '#me',
      })
    },
    handleShowDisks () {
      if (this.showPoint) {
        setLocalValue('hideMorePoint', true)
        this.showPoint = false
      }
      this.$router.push({
        name: 'disks',
        query: this.$route.query,
        hash: '#me',
      })
    },
    gotoServicePage () {
      if (this.showPoint) {
        setLocalValue('hideMorePoint', true)
        this.showPoint = false
      }
      this.$router.push({
        name: 'services',
        query: this.$route.query,
        // hash: '#me',
      })
    },
    gotoHelpPage () {
      this.$router.push({
        name: 'help',
        query: this.$route.query,
        hash: '#me',
      })
    },
  },
})
